import { api } from './api';
import { Team } from '../types';

export interface TeamsResponse {
    success: boolean;
    teams: Team[];
}

export interface TeamResponse {
    success: boolean;
    team: Team;
}

export const teamService = {
    // includeAll=true returns every active team, not just those that received a
    // preseason Voronoi assignment. The map needs this because a team can own
    // territory purely through conquest (e.g. taking a rival's land) without ever
    // holding initial land — otherwise its logo marker can't resolve.
    getTeamsByLeague: async (leagueId: string, includeAll = false): Promise<TeamsResponse> => {
        const path = includeAll ? `/teams/${leagueId}/teams?all=true` : `/teams/${leagueId}/teams`;
        const response = await api.get<TeamsResponse>(path);
        if (response.success && response.data) {
            return response.data as TeamsResponse;
        }
        throw new Error(response.error || 'Failed to fetch teams');
    },

    getTeam: async (teamId: number): Promise<TeamResponse> => {
        const response = await api.get<TeamResponse>(`/teams/${teamId}`);
        if (response.success && response.data) {
            return response.data as TeamResponse;
        }
        throw new Error(response.error || 'Failed to fetch team');
    },
};

